module.exports = __webpack_public_path__ + "static/blog48-1698a5494bb5b04a3d76e9480d1dd6ed.png";